import React, { useEffect, useState } from "react";
import amanecer from "../../../assets/backgrounds/amanecer.webp";
import mañana from "../../../assets/backgrounds/mañana.webp";
import noche from "../../../assets/backgrounds/noche.webp";
import tarde from "../../../assets/backgrounds/tarde.webp";
import Card from "../../../components/lab_turn/Card";
import CommonTitle from "../../../components/CommonTitle";
import { isGreater, isWithinRange, parseTime } from "../../../utils/timeFuncs";
import { IoAlertCircleOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { TbClockExclamation } from "react-icons/tb";

const images = {
  Madrugada: amanecer,
  Mañana: mañana,
  Noche: noche,
  Tarde: tarde,
};

const times = {
  Madrugada: { text: "4 am a 5:59 am", start: "04:00 AM", end: "05:59 AM" },
  Mañana: { text: "6 am a 11:59 am", start: "06:00 AM", end: "11:59 AM" },
  Tarde: { text: "12 pm a 5:59 pm", start: "12:00 PM", end: "05:59 PM" },
  Noche: { text: "6 pm a 8:30 pm", start: "06:00 PM", end: "08:30 PM" },
};

const LabTurn = ({ turn }) => {
  const [loading, setLoading] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [lateReg, setLateReg] = useState(false);

  const checkActiveStatus = () => {
    const currentHour = new Date().toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const currentTime = parseTime(currentHour);
    const { start, end } = times[turn] || {};
    const activeStatus =
      start && end ? isWithinRange(currentTime, start, end) : false;
    setIsActive(activeStatus);
    const timeIsGreater = isGreater(currentTime, end);
    setLateReg(timeIsGreater);
    setLoading(false);
  };

  useEffect(() => {
    checkActiveStatus();
    const interval = setInterval(() => {
      checkActiveStatus();
    }, 1000);
    return () => clearInterval(interval);
  }, [turn]);

  if (loading) return <div>Loading...</div>;
  else if (!isActive && !lateReg)
    return (
      <div className="flex flex-col w-full items-center justify-center gap-y-6 h-[100vh] font-poppins bg-gradient-to-b from-white via-light-green-50 to-white">
        <IoAlertCircleOutline className="h-[100px] w-[100px] text-dark-green" />
        <h2 className="text-3xl text-dark-green font-bold">
          Turno no disponible
        </h2>
        <Link to="/home/registroLaboratorio">
          <button
            className={` w-fit bg-light-purple-600 text-xl  flex justify-center rounded-full py-4 px-8 text-white hover:bg-dark-purple transition-all duration-100 font-bold font-poppins `}
          >
            <span className="flex flex-row items-center gap-x-2">
              <span>Volver</span>
            </span>
          </button>
        </Link>
      </div>
    );
  else
    return (
      <div className="w-full flex flex-col">
        <CommonTitle
          img={images[turn]}
          title={turn}
          text={`El procedimiento se toma entre las ${times[turn].text}`}
          rounded_img={true}
        >
          {lateReg && (
            <div className="flex flex-col gap-y-2 items-center">
              <div className=" flex flex-row items-center bg-[#fea930] rounded-full font-poppins px-6 py-4 text-white font-bold">
                Registro tardío &nbsp;
                <TbClockExclamation className="w-[25px] h-[25px]" />
              </div>
            </div>
          )}
        </CommonTitle>
        <div className="w-full flex justify-center p-2 md:p-6">
          <div className="flex flex-wrap max-w-[1100px] w-full justify-center">
            <Card prop={"Temperatura"} isLateReg={lateReg} />
            <Card prop={"Humedad"} isLateReg={lateReg} />
            <Card prop={"Luz"} isLateReg={lateReg} />
            <Card prop={"Ph"} isLateReg={lateReg} />
          </div>
        </div>
      </div>
    );
};

export default LabTurn;
